
// LOADER - START
define('sdl-media-manager.player',['jquery'],function($){
$(function(){

 loadVideoAndStills = function() {

		$(".customMMPlayer").each(loadPlayer);
	 
		$(document).bind('player-ready', function (e) {
			showVideoContainer(e.target.parentElement);
		});

		$(document).bind('show-layer-endstate', function (e) {
			console.log('event "show-layer-endstate" was fired!!' );
			showEndStateImage(e.target.parentElement);
		});
		
		$(document).bind('show-layer-endstate', function (e) {
			console.log('event "show-layer-endstate" was fired!!' );
			showEndStateImage(e.target.parentElement);
		});
	};
		
	var loadPlayer = function(index) {
		
		var thyPlayerEl = $(this);
		var distributionUrl = thyPlayerEl.attr("data-mmDistributionUrl");
		if (!distributionUrl) {
			console.debug("stillUrl() no data-mmDistributionUrl attribute found");
			return;
		}
        
        var languageCodeMap = loadLangCountryMap();
        var metaLangCountry = $("meta[name=languagecountry]").attr("content");
        var mediaManagerLangCountry = languageCodeMap[metaLangCountry];
        console.debug("mediaManagerLangCountry: " + mediaManagerLangCountry);
		
		distributionUrl = distributionUrl.toLowerCase();
		loadStill(thyPlayerEl, distributionUrl, mediaManagerLangCountry);
		loadPlayerScript(thyPlayerEl, distributionUrl, index, mediaManagerLangCountry);
	};

	var loadStill = function(thyPlayerEl, distributionUrl, mediaManagerLangCountry) {
		
		var stillUrl = distributionUrl.replace("distributions/?o=", "distributions/?f=").concat("&ext=.jpg");
        if (typeof mediaManagerLangCountry != 'undefined') {
            stillUrl = stillUrl.concat("&sl=" + mediaManagerLangCountry);
        }
		console.debug("stillUrl: " + stillUrl);

		if(thyPlayerEl.find(".still").first().has("img").length == 0)
			thyPlayerEl.find(".still").first().append('<img src="' + stillUrl + '"/>');
		
		showOverlays(thyPlayerEl);
		
		$.event.trigger({
				type: "stillImageLoaded",
				message:  "Still image finish loaded " + stillUrl,
				time: new Date(),
				thyPlayerEl:thyPlayerEl
		});
	};

	var loadPlayerScript = function(playerElement, distributionUrl, index, mediaManagerLangCountry) {
		
		//GET THE DISTRIBUTION GUID, THE ID OF THE PLAYER ELEMENT IS THE DISTRIBUTION GUID
		var distGuid = getParameterByName(distributionUrl,"o");
		var elementId = distGuid+"-"+index;
		playerElement.attr("elementId",elementId);
		
		var playerGuidEl = $(playerElement).find(".videoContainer");
		playerGuidEl.append("<div id="+ elementId +"></div>" );
		
		var ajaxLoaderUrl = distributionUrl.replace("distributions/?o=", "distributions/embed/?o=").concat("&trgt=" + elementId);
        if (typeof mediaManagerLangCountry != 'undefined') {
            ajaxLoaderUrl = ajaxLoaderUrl.concat("&sl=" + mediaManagerLangCountry);
        }
		
		//HIDE THE PLAYER ELEMENT
		$("#"+elementId).css("opacity", 0);
		
		//LOAD THE SCRIPT
		$.getScript(ajaxLoaderUrl);
	};

	var setPlayerSize = function(thyPlayerEl)
	{	
		var playerWidth = thyPlayerEl.attr("data-mmWidth")
		var playerHeight = thyPlayerEl.attr("data-mmHeight");
		
		var videoContainer = $(thyPlayerEl).find(".videoContainer");
		var playerGuidEl = $(thyPlayerEl).find(".videoContainer").children().last();
		var mmPlaceholderEl = $(playerGuidEl).children().last()
		var projekktorEl = mmPlaceholderEl.children().first()
		
		videoContainer.css({ 'width': '100%', 'height': '100%' });
		$(playerGuidEl).css({ 'width': '100%', 'height': '100%' });
		mmPlaceholderEl.css({ 'width': '100%', 'height': '100%' });
		projekktorEl.css({ 'width': '100%', 'height': '100%'});	
	}

	var showVideoContainer = function(mmPlaceholderEL) {

		var thyPlayerEl = $(mmPlaceholderEL).parent().parent();
		subscribePlayingEvent(mmPlaceholderEL);
		
		setPlayerSize(thyPlayerEl);
		$.event.trigger({
				type: "videoLoaded",
				message:  "Video player finish loaded",
				time: new Date(),
				thyPlayerEl:thyPlayerEl
		});
		
	

		//FADE-IN THE PLAYER ELEMENT AND HIDE THE STILL
		$(mmPlaceholderEL).fadeTo("Fast", 1, function() {
			var still = $(mmPlaceholderEL).parent().parent().find(".still");
			still.css("opacity", 0);
			still.css("display", 'none');
		});
	};

	function subscribePlayingEvent(mmPlaceholderEL) {
		var thyPlayerEl = $(mmPlaceholderEL).parent().parent();
		var html5VideoElement = $(mmPlaceholderEL).find("video").get(0);
		
		$("video").bind("playing", function() {
			hideOverlays(thyPlayerEl);
		});
	}
		
	var showEndStateImage = function(playerGuidEl) {
		
		var endStateEl = $(playerGuidEl).parent().parent().find(".endState");
		if(!$(endStateEl).exists())
			return;
		
		/////////////////////////////
		var thyPlayerEl = $(playerGuidEl).parent().parent()
		var playerWidth = thyPlayerEl.attr("data-mmWidth")
		var playerHeight = thyPlayerEl.attr("data-mmHeight");
	

		if($(endStateEl)){
			var endImageEl = $(endStateEl).find(".endImg");
		}

		if(!$(endImageEl).exists())
			return;


		if(endStateEl && endStateEl != undefined && !$(endImageEl).exists())
		{
			var stillUrl = getStillURL(thyPlayerEl);
			endStateEl.first().append('<img class="endImg" src="' + stillUrl + '"/>');
		}
		
		$(endImageEl).css({ 'width': playerWidth }); // HEIGHT IS NOT INCLUDED TO PRESERVE ASPECT RATIO
		//$(thyPlayerEl).css("height",playerHeight);
		/////////////////////////////
		
		$.event.trigger({
				type: "endStateLoaded",
				message:  "End state image loaded ",
				time: new Date(),
				thyPlayerEl:thyPlayerEl
		});
		
		//FADE-IN THE END STATE IMAGE AND HIDE THE VIDEO PLAYER
		$(playerGuidEl).css("z-index","1");
		$(endStateEl).fadeTo("Slow", 1, function() {
			$(playerGuidEl).css("display","none");
			showOverlays(thyPlayerEl);
		});
	};
	
	var showOverlays = function(thyPlayerEl) {
		var overlays = $(thyPlayerEl).find(".overlays");
		var readMoreImg = $(overlays).find("img");
		

		$(overlays).css('display','block');
		
		//adjust the readmore image to the container
		$(readMoreImg).one("load", function() {
			adjustImgToParentTag(readMoreImg);
		}).each(function() {
		  if(this.complete) 
		  {
			  $(this).load();
		  }
		});
	}
	
	var hideOverlays = function(thyPlayerEl) {
		var overlays = $(thyPlayerEl).find(".overlays");

		$(overlays).css('display','none');
	}
	
	
	var getStillURL = function (thyPlayerEl)	{
		var distributionUrl = thyPlayerEl.attr("data-mmDistributionUrl").toLowerCase();;
			var stillUrl = distributionUrl.replace("distributions/?o=", "distributions/?f=").concat("&ext=.jpg");
			console.debug("stillUrl: " + stillUrl);
			return stillUrl;
	};

	var getParameterByName = function(url, name) {
			var name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
			var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
				results = regex.exec(url);
			return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
		}
    
    var loadLangCountryMap = function() {
        var languageCodeMap = {};
        languageCodeMap['de-CH'] = 'de-CH';
        languageCodeMap['de-DE'] = 'de-DE';
        languageCodeMap['de-TR'] = 'de';
        languageCodeMap['en-TR'] = 'en';
        languageCodeMap['en-UK'] = 'en-GB';
        languageCodeMap['es-ES'] = 'es-ES';
        languageCodeMap['tr-CH'] = 'tr';
        languageCodeMap['tr-TR'] = 'tr-TR';
        languageCodeMap['ar-AE'] = 'ar-AE';
        languageCodeMap['ar-BH'] = 'ar-BH';
        languageCodeMap['ar-DJ'] = 'ar';
        languageCodeMap['ar-DZ'] = 'ar-DZ';
        languageCodeMap['ar-EG'] = 'ar-EG';
        languageCodeMap['ar-ET'] = 'ar';
        languageCodeMap['ar-IL'] = 'ar';
        languageCodeMap['ar-IQ'] = 'ar-IQ';
        languageCodeMap['ar-JO'] = 'ar-JO';
        languageCodeMap['ar-KW'] = 'ar-KW';
        languageCodeMap['ar-LB'] = 'ar-LB';
        languageCodeMap['ar-LY'] = 'ar-LY';
        languageCodeMap['ar-MA'] = 'ar-MA';
        languageCodeMap['ar-MR'] = 'ar';
        languageCodeMap['ar-OM'] = 'ar-OM';
        languageCodeMap['ar-QA'] = 'ar-QA';
        languageCodeMap['ar-SA'] = 'ar-SA';
        languageCodeMap['ar-SD'] = 'ar';
        languageCodeMap['ar-SO'] = 'ar';
        languageCodeMap['ar-SY'] = 'ar-SY';
        languageCodeMap['ar-TD'] = 'ar';
        languageCodeMap['ar-TN'] = 'ar-TN';
        languageCodeMap['ar-YE'] = 'ar-YE';
        languageCodeMap['cn-CN'] = 'zh';
        languageCodeMap['cn-HK'] = 'zh';
        languageCodeMap['cn-MY'] = 'zh';
        languageCodeMap['cn-TH'] = 'zh';
        languageCodeMap['de-AT'] = 'de-AT';
        languageCodeMap['de-BE'] = 'de';
        languageCodeMap['de-CH'] = 'de-CH';
        languageCodeMap['de-DE'] = 'de-DE';
        languageCodeMap['de-LU'] = 'de-LU';
        languageCodeMap['de-SI'] = 'de';
        languageCodeMap['en-AE'] = 'en';
        languageCodeMap['en-AF'] = 'en';
        languageCodeMap['en-AL'] = 'en';
        languageCodeMap['en-AR'] = 'en';
        languageCodeMap['en-AT'] = 'en';
        languageCodeMap['en-AU'] = 'en-AU';
        languageCodeMap['en-AZ'] = 'en';
        languageCodeMap['en-BA'] = 'en';
        languageCodeMap['en-BD'] = 'en';
        languageCodeMap['en-BE'] = 'en';
        languageCodeMap['en-BF'] = 'en';
        languageCodeMap['en-BG'] = 'en';
        languageCodeMap['en-BH'] = 'en';
        languageCodeMap['en-BJ'] = 'en';
        languageCodeMap['en-BR'] = 'en';
        languageCodeMap['en-BY'] = 'en';
        languageCodeMap['en-CA'] = 'en-CA';
        languageCodeMap['en-CD'] = 'en';
        languageCodeMap['en-CH'] = 'en';
        languageCodeMap['en-CI'] = 'en';
        languageCodeMap['en-CM'] = 'en';
        languageCodeMap['en-CN'] = 'en';
        languageCodeMap['en-CT'] = 'en';
        languageCodeMap['en-CZ'] = 'en';
        languageCodeMap['en-DE'] = 'en';
        languageCodeMap['en-DJ'] = 'en';
        languageCodeMap['en-DK'] = 'en';
        languageCodeMap['en-DZ'] = 'en';
        languageCodeMap['en-EE'] = 'en';
        languageCodeMap['en-EG'] = 'en';
        languageCodeMap['en-ES'] = 'en';
        languageCodeMap['en-ET'] = 'en';
        languageCodeMap['en-FI'] = 'en';
        languageCodeMap['en-FR'] = 'en';
        languageCodeMap['en-GA'] = 'en';
        languageCodeMap['en-GE'] = 'en';
        languageCodeMap['en-GH'] = 'en';
        languageCodeMap['en-GN'] = 'en';
        languageCodeMap['en-GR'] = 'en';
        languageCodeMap['en-HK'] = 'en';
        languageCodeMap['en-HR'] = 'en';
        languageCodeMap['en-HU'] = 'en';
        languageCodeMap['en-ID'] = 'en';
        languageCodeMap['en-IE'] = 'en-IE';
        languageCodeMap['en-IL'] = 'en';
        languageCodeMap['en-IN'] = 'en';
        languageCodeMap['en-IQ'] = 'en';
        languageCodeMap['en-IR'] = 'en';
        languageCodeMap['en-IT'] = 'en';
        languageCodeMap['en-JA'] = 'en';
        languageCodeMap['en-JO'] = 'en';
        languageCodeMap['en-KE'] = 'en';
        languageCodeMap['en-KG'] = 'en';
        languageCodeMap['en-KR'] = 'en';
        languageCodeMap['en-KW'] = 'en';
        languageCodeMap['en-KZ'] = 'en';
        languageCodeMap['en-LB'] = 'en';
        languageCodeMap['en-LK'] = 'en';
        languageCodeMap['en-LT'] = 'en';
        languageCodeMap['en-LU'] = 'en';
        languageCodeMap['en-LV'] = 'en';
        languageCodeMap['en-LY'] = 'en';
        languageCodeMap['en-MA'] = 'en';
        languageCodeMap['en-MD'] = 'en';
        languageCodeMap['en-ME'] = 'en';
        languageCodeMap['en-MK'] = 'en';
        languageCodeMap['en-ML'] = 'en';
        languageCodeMap['en-MN'] = 'en';
        languageCodeMap['en-MR'] = 'en';
        languageCodeMap['en-MT'] = 'en';
        languageCodeMap['en-MV'] = 'en';
        languageCodeMap['en-MY'] = 'en';
        languageCodeMap['en-NE'] = 'en';
        languageCodeMap['en-NG'] = 'en';
        languageCodeMap['en-NL'] = 'en';
        languageCodeMap['en-NO'] = 'en';
        languageCodeMap['en-NP'] = 'en';
        languageCodeMap['en-NZ'] = 'en-NZ';
        languageCodeMap['en-OM'] = 'en';
        languageCodeMap['en-PK'] = 'en';
        languageCodeMap['en-PL'] = 'en';
        languageCodeMap['en-PT'] = 'en';
        languageCodeMap['en-QA'] = 'en';
        languageCodeMap['en-RO'] = 'en';
        languageCodeMap['en-RS'] = 'en';
        languageCodeMap['en-RU'] = 'en';
        languageCodeMap['en-RW'] = 'en';
        languageCodeMap['en-SA'] = 'en';
        languageCodeMap['en-SD'] = 'en';
        languageCodeMap['en-SE'] = 'en';
        languageCodeMap['en-SG'] = 'en';
        languageCodeMap['en-SI'] = 'en';
        languageCodeMap['en-SN'] = 'en';
        languageCodeMap['en-SO'] = 'en';
        languageCodeMap['en-SY'] = 'en';
        languageCodeMap['en-TD'] = 'en';
        languageCodeMap['en-TH'] = 'en';
        languageCodeMap['en-TJ'] = 'en';
        languageCodeMap['en-TM'] = 'en';
        languageCodeMap['en-TN'] = 'en';
        languageCodeMap['en-TR'] = 'en';
        languageCodeMap['en-TZ'] = 'en';
        languageCodeMap['en-UA'] = 'en';
        languageCodeMap['en-UG'] = 'en';
        languageCodeMap['en-UK'] = 'en-GB';
        languageCodeMap['en-US'] = 'en-US';
        languageCodeMap['en-UZ'] = 'en';
        languageCodeMap['en-VN'] = 'en';
        languageCodeMap['en-XK'] = 'en';
        languageCodeMap['en-YE'] = 'en';
        languageCodeMap['en-ZA'] = 'en';
        languageCodeMap['en-ZM'] = 'en';
        languageCodeMap['es-AR'] = 'es-AR';
        languageCodeMap['es-ES'] = 'es-ES';
        languageCodeMap['es-US'] = 'es';
        languageCodeMap['fr-BE'] = 'fr-BE';
        languageCodeMap['fr-BF'] = 'fr';
        languageCodeMap['fr-BJ'] = 'fr';
        languageCodeMap['fr-CA'] = 'fr-CA';
        languageCodeMap['fr-CD'] = 'fr';
        languageCodeMap['fr-CH'] = 'fr-CH';
        languageCodeMap['fr-CI'] = 'fr';
        languageCodeMap['fr-CM'] = 'fr';
        languageCodeMap['fr-DJ'] = 'fr';
        languageCodeMap['fr-DZ'] = 'fr';
        languageCodeMap['fr-FR'] = 'fr-FR';
        languageCodeMap['fr-GA'] = 'fr';
        languageCodeMap['fr-GN'] = 'fr';
        languageCodeMap['fr-LU'] = 'fr-LU';
        languageCodeMap['fr-MA'] = 'fr';
        languageCodeMap['fr-MR'] = 'fr';
        languageCodeMap['fr-NE'] = 'fr';
        languageCodeMap['fr-RW'] = 'fr';
        languageCodeMap['fr-SN'] = 'fr';
        languageCodeMap['fr-TD'] = 'fr';
        languageCodeMap['fr-TN'] = 'fr';
        languageCodeMap['it-CH'] = 'it-CH';
        languageCodeMap['it-IT'] = 'it-IT';
        languageCodeMap['ja-JA'] = 'ja-JP';
        languageCodeMap['pt-BR'] = 'pt-BR';
        languageCodeMap['pt-PT'] = 'pt-PT';
        languageCodeMap['ru-AZ'] = 'ru';
        languageCodeMap['ru-BY'] = 'ru';
        languageCodeMap['ru-EE'] = 'ru';
        languageCodeMap['ru-GE'] = 'ru';
        languageCodeMap['ru-KG'] = 'ru';
        languageCodeMap['ru-KZ'] = 'ru';
        languageCodeMap['ru-LT'] = 'ru';
        languageCodeMap['ru-LV'] = 'ru';
        languageCodeMap['ru-MD'] = 'ru';
        languageCodeMap['ru-RU'] = 'ru-RU';
        languageCodeMap['ru-TJ'] = 'ru';
        languageCodeMap['ru-TM'] = 'ru';
        languageCodeMap['ru-UA'] = 'ru';
        languageCodeMap['ru-UZ'] = 'ru';
        languageCodeMap['tr-AL'] = 'tr';
        languageCodeMap['tr-AT'] = 'tr';
        languageCodeMap['tr-AZ'] = 'tr';
        languageCodeMap['tr-BA'] = 'tr';
        languageCodeMap['tr-BE'] = 'tr';
        languageCodeMap['tr-BG'] = 'tr';
        languageCodeMap['tr-CD'] = 'tr';
        languageCodeMap['tr-CH'] = 'tr';
        languageCodeMap['tr-CN'] = 'tr';
        languageCodeMap['tr-DE'] = 'tr';
        languageCodeMap['tr-DK'] = 'tr';
        languageCodeMap['tr-DZ'] = 'tr';
        languageCodeMap['tr-EG'] = 'tr';
        languageCodeMap['tr-ES'] = 'tr';
        languageCodeMap['tr-FR'] = 'tr';
        languageCodeMap['tr-IR'] = 'tr';
        languageCodeMap['tr-IT'] = 'tr';
        languageCodeMap['tr-JA'] = 'tr';
        languageCodeMap['tr-LY'] = 'tr';
        languageCodeMap['tr-NL'] = 'tr';
        languageCodeMap['tr-NO'] = 'tr';
        languageCodeMap['tr-RU'] = 'tr';
        languageCodeMap['tr-SA'] = 'tr';
        languageCodeMap['tr-SE'] = 'tr';
        languageCodeMap['tr-TM'] = 'tr';
        languageCodeMap['tr-TR'] = 'tr-TR';
        languageCodeMap['tr-UA'] = 'tr';
        languageCodeMap['tr-UK'] = 'tr';
        languageCodeMap['tr-US'] = 'tr';
        languageCodeMap['tr-XK'] = 'tr';
        return languageCodeMap;
    }
    
	$.fn.exists = function () {
		return this.length !== 0;
	}
});
// LOADER - END

//RESIZE - START

$(function(){
	//EVENT DEFINITION	- START
	$(".customMMPlayer").resize(function(){
		resizePlayers();
	});

	$(document).on("stillImageLoaded", function (evt) {
		setStillSize(evt.thyPlayerEl);
	});
	
	$(document).on("endStateLoaded", function (evt) {
		setEndStateSize(evt.thyPlayerEl);
	});

	$(document).on("videoLoaded", function (evt) {
		setPlayerSize(evt.thyPlayerEl);
	});
	//EVENT DEFINITION	- END
	
	resizePlayers = function()
	{
		$(".customMMPlayer").each(resizeMediaManagerPlayer);
	};	
		
	setPlayerSize = function(thyPlayerEl)
	{	
		var ratio = thyPlayerEl.attr("data-mmHeight") / thyPlayerEl.attr("data-mmWidth");
		
		var playerWidth = $(thyPlayerEl).width();
		var playerHeight = playerWidth * ratio;
		
		var videoContainer = $(thyPlayerEl).find(".videoContainer");
		var playerGuidEl = $(thyPlayerEl).find(".videoContainer").children().last();
		var mmPlaceholderEl = $(playerGuidEl).children().last()
		var projekktorEl = mmPlaceholderEl.children().first()
		
		videoContainer.css({ 'width': '100%', 'height': '100%' });
		$(playerGuidEl).css({ 'width': '100%', 'height': '100%' });
		mmPlaceholderEl.css({ 'width': '100%', 'height': '100%' });
		projekktorEl.css({ 'width': '100%', 'height': '100%'});	
	}

	setStillSize = function(thyPlayerEl)
	{
		var ratio = thyPlayerEl.attr("data-mmHeight") / thyPlayerEl.attr("data-mmWidth");
		
		var playerWidth = $(thyPlayerEl).width();
		var playerHeight = playerWidth * ratio;
		if(!window.isPhoneOrTablet){
			$(thyPlayerEl).css("height",playerHeight);
		}
		else{
			$(thyPlayerEl).css("height",'200px');
		}
		
		var img = thyPlayerEl.find(".still").children().last();
		$(img).one("load", function() {
		 adjustImgToParentTag(img);
		}).each(function() {
		  if(this.complete) 
		  {
			  $(this).load();
		  }
		});
	}
	
	adjustImgToParentTag = function(item) 
	{
		var img_height = $(item).height();
		var img_width = $(item).width();
		var img_ratio = img_height / img_width;
		
		var div_height = $(item).parent().height();
		var div_width = $(item).parent().width();
		var div_ratio = div_height / div_width;
		
		if(img_ratio < div_ratio)
		{
			var t_img_height =  div_width * img_ratio;
			var margin = (div_height - t_img_height) / 2;
			$(item).css({'margin-top': margin, 'width': "100%"});
		}
		else if(img_ratio > div_ratio)
		{
			var t_img_width =  div_height / img_ratio;
			var margin = (div_width - t_img_width) / 2;
			$(item).css({'margin-left': margin, 'height': "100%"});
		}
	}
	
	setEndStateSize = function(thyPlayerEl)
	{
		var ratio = thyPlayerEl.attr("data-mmHeight") / thyPlayerEl.attr("data-mmWidth");
		
		var playerWidth = $(thyPlayerEl).width();
		var playerHeight = playerWidth * ratio;
		
		var endStateEl = $(thyPlayerEl).find(".endState");
		var endImgEl = $(thyPlayerEl).find(".endState .endImg");
		$(endImgEl).css({ 'width': playerWidth }); 
	
		onImgLoad($(endImgEl), function(){
			if(endImgEl.height() != 0)
			{
				endStateEl.css({'display':'block'});	
				$(endStateEl).css("top", (playerHeight - endImgEl.height())/2 ); // CENTER THE END IMG IN THE VIDEO CONTAINER
			}
		});
		
		$(thyPlayerEl).css("height",playerHeight);
	}
	
	var resizeMediaManagerPlayer = function() {
		
		var thyPlayerEl = $(this);		

		setStillSize(thyPlayerEl);
		setEndStateSize(thyPlayerEl);
	}	
	
	/**
	 * Trigger a callback when the selected images are loaded:
	 * @param {String} selector
	 * @param {Function} callback
	 * src url : http://stackoverflow.com/questions/3877027/jquery-callback-on-image-load-even-when-the-image-is-cached
	  */
	var onImgLoad = function(selector, callback){
		$(selector).each(function(){
			if (this.complete || /*for IE 10-*/ $(this).height() > 0) {
				callback.apply(this);
			}
			else {
				$(this).on('load', function(){
					callback.apply(this);
				});
			}
		});
	};

});

//RESIZE - END


//VIDEO LOADER - START$(function(){
$(function(){
	$(document).ready(function(){
		loadVideoAndStills();
	});
	
	$(".replayBt").click(function(event) {		
		var thyPlayerEl = $(event.target).parent().parent();
		
		var playerGuidEl = $(thyPlayerEl).find(".videoContainer").children().last();
		var mmPlaceholderEl = $(playerGuidEl).children().last()
		
		//RESTART THE VIDEO FROM The BEGINNING
		$(playerGuidEl).css("display","block");
		mmPlaceholderEl.trigger('restart-asset');
		
		//HIDE THE ENDSTATE IMAGE
		var endStateEl = $(event.target).parent();
		endStateEl.css({'display':'none'});
		
		return false;
	});
	
	$(".readmoreBt").click(function(event) {		
		var thyPlayerEl = $(event.target).parent().parent();
		
		var playerGuidEl = $(thyPlayerEl).find(".videoContainer").children().last();
		var mmPlaceholderEl = $(playerGuidEl).children().last()
		
		alert("Read More");
		
		return false;
	});
	
		$(".shareBt").click(function(event) {		
		var thyPlayerEl = $(event.target).parent().parent();
		
		var playerGuidEl = $(thyPlayerEl).find(".videoContainer").children().last();
		var mmPlaceholderEl = $(playerGuidEl).children().last()
		
		alert("Share");
		
		return false;
	});
	
		$(".likeBt").click(function(event) {		
		var thyPlayerEl = $(event.target).parent().parent();
		
		var playerGuidEl = $(thyPlayerEl).find(".videoContainer").children().last();
		var mmPlaceholderEl = $(playerGuidEl).children().last()
		
		alert("Like")
		
		return false;
	});

});
//VIDEO LOADER - END

	
// BA-RESIZE - START
/*!
 * jQuery resize event - v1.1 - 3/14/2010
 * http://benalman.com/projects/jquery-resize-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery resize event
//
// *Version: 1.1, Last updated: 3/14/2010*
// 
// Project Home - http://benalman.com/projects/jquery-resize-plugin/
// GitHub       - http://github.com/cowboy/jquery-resize/
// Source       - http://github.com/cowboy/jquery-resize/raw/master/jquery.ba-resize.js
// (Minified)   - http://github.com/cowboy/jquery-resize/raw/master/jquery.ba-resize.min.js (1.0kb)
// 
// About: License
// 
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
// 
// About: Examples
// 
// This working example, complete with fully commented code, illustrates a few
// ways in which this plugin can be used.
// 
// resize event - http://benalman.com/code/projects/jquery-resize/examples/resize/
// 
// About: Support and Testing
// 
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
// 
// jQuery Versions - 1.3.2, 1.4.1, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-resize/unit/
// 
// About: Release History
// 
// 1.1 - (3/14/2010) Fixed a minor bug that was causing the event to trigger
//       immediately after bind in some circumstances. Also changed $.fn.data
//       to $.data to improve performance.
// 1.0 - (2/10/2010) Initial release

(function($,window,undefined){
  '$:nomunge'; // Used by YUI compressor.
  
  // A jQuery object containing all non-window elements to which the resize
  // event is bound.
  var elems = $([]),
    
    // Extend $.resize if it already exists, otherwise create it.
    jq_resize = $.resize = $.extend( $.resize, {} ),
    
    timeout_id,
    
    // Reused strings.
    str_setTimeout = 'setTimeout',
    str_resize = 'resize',
    str_data = str_resize + '-special-event',
    str_delay = 'delay',
    str_throttle = 'throttleWindow';
  
  // Property: jQuery.resize.delay
  // 
  // The numeric interval (in milliseconds) at which the resize event polling
  // loop executes. Defaults to 250.
  
  jq_resize[ str_delay ] = 250;
  
  // Property: jQuery.resize.throttleWindow
  // 
  // Throttle the native window object resize event to fire no more than once
  // every <jQuery.resize.delay> milliseconds. Defaults to true.
  // 
  // Because the window object has its own resize event, it doesn't need to be
  // provided by this plugin, and its execution can be left entirely up to the
  // browser. However, since certain browsers fire the resize event continuously
  // while others do not, enabling this will throttle the window resize event,
  // making event behavior consistent across all elements in all browsers.
  // 
  // While setting this property to false will disable window object resize
  // event throttling, please note that this property must be changed before any
  // window object resize event callbacks are bound.
  
  jq_resize[ str_throttle ] = true;
  
  // Event: resize event
  // 
  // Fired when an element's width or height changes. Because browsers only
  // provide this event for the window element, for other elements a polling
  // loop is initialized, running every <jQuery.resize.delay> milliseconds
  // to see if elements' dimensions have changed. You may bind with either
  // .resize( fn ) or .bind( "resize", fn ), and unbind with .unbind( "resize" ).
  // 
  // Usage:
  // 
  // > jQuery('selector').bind( 'resize', function(e) {
  // >   // element's width or height has changed!
  // >   ...
  // > });
  // 
  // Additional Notes:
  // 
  // * The polling loop is not created until at least one callback is actually
  //   bound to the 'resize' event, and this single polling loop is shared
  //   across all elements.
  // 
  // Double firing issue in jQuery 1.3.2:
  // 
  // While this plugin works in jQuery 1.3.2, if an element's event callbacks
  // are manually triggered via .trigger( 'resize' ) or .resize() those
  // callbacks may double-fire, due to limitations in the jQuery 1.3.2 special
  // events system. This is not an issue when using jQuery 1.4+.
  // 
  // > // While this works in jQuery 1.4+
  // > $(elem).css({ width: new_w, height: new_h }).resize();
  // > 
  // > // In jQuery 1.3.2, you need to do this:
  // > var elem = $(elem);
  // > elem.css({ width: new_w, height: new_h });
  // > elem.data( 'resize-special-event', { width: elem.width(), height: elem.height() } );
  // > elem.resize();
      
  $.event.special[ str_resize ] = {
    
    // Called only when the first 'resize' event callback is bound per element.
    setup: function() {
      // Since window has its own native 'resize' event, return false so that
      // jQuery will bind the event using DOM methods. Since only 'window'
      // objects have a .setTimeout method, this should be a sufficient test.
      // Unless, of course, we're throttling the 'resize' event for window.
      if ( !jq_resize[ str_throttle ] && this[ str_setTimeout ] ) { return false; }
      
      var elem = $(this);
      
      // Add this element to the list of internal elements to monitor.
      elems = elems.add( elem );
      
      // Initialize data store on the element.
      $.data( this, str_data, { w: elem.width(), h: elem.height() } );
      
      // If this is the first element added, start the polling loop.
      if ( elems.length === 1 ) {
        loopy();
      }
    },
    
    // Called only when the last 'resize' event callback is unbound per element.
    teardown: function() {
      // Since window has its own native 'resize' event, return false so that
      // jQuery will unbind the event using DOM methods. Since only 'window'
      // objects have a .setTimeout method, this should be a sufficient test.
      // Unless, of course, we're throttling the 'resize' event for window.
      if ( !jq_resize[ str_throttle ] && this[ str_setTimeout ] ) { return false; }
      
      var elem = $(this);
      
      // Remove this element from the list of internal elements to monitor.
      elems = elems.not( elem );
      
      // Remove any data stored on the element.
      elem.removeData( str_data );
      
      // If this is the last element removed, stop the polling loop.
      if ( !elems.length ) {
        clearTimeout( timeout_id );
      }
    },
    
    // Called every time a 'resize' event callback is bound per element (new in
    // jQuery 1.4).
    add: function( handleObj ) {
      // Since window has its own native 'resize' event, return false so that
      // jQuery doesn't modify the event object. Unless, of course, we're
      // throttling the 'resize' event for window.
      if ( !jq_resize[ str_throttle ] && this[ str_setTimeout ] ) { return false; }
      
      var old_handler;
      
      // The new_handler function is executed every time the event is triggered.
      // This is used to update the internal element data store with the width
      // and height when the event is triggered manually, to avoid double-firing
      // of the event callback. See the "Double firing issue in jQuery 1.3.2"
      // comments above for more information.
      
      function new_handler( e, w, h ) {
        var elem = $(this),
          data = $.data( this, str_data );
        
        // If called from the polling loop, w and h will be passed in as
        // arguments. If called manually, via .trigger( 'resize' ) or .resize(),
        // those values will need to be computed.
        if(data){
            data.w = w !== undefined ? w : elem.width();
            data.h = h !== undefined ? h : elem.height();
        }

        
        old_handler.apply( this, arguments );
      };
      
      // This may seem a little complicated, but it normalizes the special event
      // .add method between jQuery 1.4/1.4.1 and 1.4.2+
      if ( $.isFunction( handleObj ) ) {
        // 1.4, 1.4.1
        old_handler = handleObj;
        return new_handler;
      } else {
        // 1.4.2+
        old_handler = handleObj.handler;
        handleObj.handler = new_handler;
      }
    }
    
  };
  
  function loopy() {
    
    // Start the polling loop, asynchronously.
    timeout_id = window[ str_setTimeout ](function(){
      
      // Iterate over all elements to which the 'resize' event is bound.
      elems.each(function(){
        var elem = $(this),
          width = elem.width(),
          height = elem.height(),
          data = $.data( this, str_data );
        
        // If element size has changed since the last time, update the element
        // data store and trigger the 'resize' event.
        if ( width !== data.w || height !== data.h ) {
          elem.trigger( str_resize, [ data.w = width, data.h = height ] );
        }
        
      });
      
      // Loop.
      loopy();
      
    }, jq_resize[ str_delay ] );
    
  };
  
})(jQuery,this);
});
// BA-RESIZE - END;